<div *ngIf="preference">
  <div class="content">
    <h5>General</h5>
    <div class="title">
      <label>Confirm before deleting</label>
    </div>
    <div class="slide">
      <mat-slide-toggle [ngModel]="preference.confirm_delete" (change)="updatePreferences('confirm_delete')">
        <span>{{preference.confirm_delete}}</span>
      </mat-slide-toggle>
    </div>
    <div class="title">
      <label>Hide completed subtask</label>
    </div>
    <div class="slide">
      <mat-slide-toggle [ngModel]="preference.hide_completed_subtask_on"
        (change)="updatePreferences('hide_completed_subtask_on')">
        <span>{{preference.hide_completed_subtask_on}}</span></mat-slide-toggle>
    </div>
    <div class="title">
      <label>Sort by creation date</label>
    </div>
    <div class="slide">
      <mat-slide-toggle [ngModel]="preference.sort_by_creation_date_on"
        (change)="updatePreferences('sort_by_creation_date_on')">
        <span>{{preference.sort_by_creation_date_on}}</span></mat-slide-toggle>
    </div>

    <div class="title">
      <label>Turn on reminder notifications</label>
    </div>
    <div class="slide">
      <mat-slide-toggle [ngModel]="preference.reminder_on" (change)="updatePreferences('reminder_on')">
        <span>{{preference.reminder_on }}</span>
      </mat-slide-toggle>
    </div>

    <h5>Smart lists</h5>
    <div class="title">
      <label>Assigned to Me</label>
    </div>
    <div class="slide">
      <mat-slide-toggle [ngModel]="preference.assigned_to_me_on" (change)="updatePreferences('assigned_to_me_on')">
        <span>{{preference.assigned_to_me_on}}</span>
      </mat-slide-toggle>
    </div>
    <div class="title">
      <label>Important</label>
    </div>
    <div class="slide">
      <mat-slide-toggle [ngModel]="preference.important_on" (change)="updatePreferences('important_on')">
        <span>{{preference.important_on}}</span>
      </mat-slide-toggle>
    </div>
    <div class="title">
      <label>Priority</label>
    </div>
    <div class="slide">
      <mat-slide-toggle [ngModel]="preference.priority_on" (change)="updatePreferences('priority_on')">
        <span>{{preference.priority_on}}</span>
      </mat-slide-toggle>
    </div>
    <div class="title">
      <label>Planned</label>
    </div>
    <div class="slide">
      <mat-slide-toggle [ngModel]="preference.planned_on" (change)="updatePreferences('planned_on')">
        <span>{{preference.planned_on }}</span>
      </mat-slide-toggle>
    </div>
    <div class="title">
      <label>Auto-hide empty smart lists</label>
    </div>
    <div class="slide">
      <mat-slide-toggle [ngModel]="preference.auto_hide_empty_list_on"
        (change)="updatePreferences('auto_hide_empty_list_on')">
        <span>{{preference.auto_hide_empty_list_on }}</span>
      </mat-slide-toggle>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/content/common/todo-tab/components/settings-side-nav/settings-side-nav.component.html